@if(!showBillingCatogory){
@if (this.container.items.resource && this.container.items.resource.length > 0) {
<div class="col">
  <dhs-data-grid [fields]="fields" [config]="config" [bulkActionsConfig]="bulkActionsConfig" [data]="container.items"
    (checkBoxDataEmit)="onSelectionConfirmed($event)">
  </dhs-data-grid>
</div>
}
@if (!this.container.items.resource || this.container.items.resource.length === 0) {
<div class="col text-center p-3">No package items found.</div>
}
}
@if(showBillingCatogory){
  @if (previewBillingItems && previewBillingItems.length > 0) {
    <div class="col-12 mt-2 p-0 table-responsive">
      <table class="base-table">
        <thead>
          <tr>
            <th>Service Name</th>
            <th>Service Type</th>
            <th>Current Price</th>
            <th>New Price</th>
            <th>Price Available</th>
          </tr>
        </thead>
        <tbody>
          @for (item of previewBillingItems; track item; let i = $index) {
            <tr>
              <td>{{item.service_name}}</td>
              <td>{{item.service_type_code}}</td>
              <td>{{item.current_price}}</td>
              <td>{{item.new_price}}</td>
              <td>{{item.price_available ? 'Yes' : 'No'}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="col-12 mt-3 p-0 d-flex justify-content-end">
      <div class="text-end me-4">
        <div>Current Total Amount</div>
        <div>New Total Amount</div>
      </div>
      <div class="text-end">
        <div>{{previewCurrentTotalAmount}}</div>
        <div>{{previewNewTotalAmount}}</div>
      </div>
    </div>
  }
  @if (!previewBillingItems || previewBillingItems.length === 0) {
    <div class="col text-center p-3">No billing item price changes found.</div>
  }
}